export const CLEANUP_PLATFORM_PAGE_STATE = 'cleanup-platform-page-state';
const cleanupPlatformPageState = () => ({ type: CLEANUP_PLATFORM_PAGE_STATE });
export default cleanupPlatformPageState;
